var map = {
	"./coach_01.png": 54548,
	"./coach_02.png": 23173,
	"./coach_03.png": 18711,
	"./coach_04.png": 9199,
	"./coach_05.png": 63149,
	"./coach_06.png": 3058
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35084;